/** @jsxImportSource @emotion/react */

import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { VISIT_STATUS } from "apis/visitors/type";
import { useState } from "react";
import Icon from "uis/Icon";
import Select_V2 from "uis/Select/select_v2";

const TagContainer = styled.div<{ color?: string; backgroundColor?: string }>`
    max-width: 95px;
    width: max-content;
    padding: 0 12px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${(props) => props.backgroundColor};
    color: ${(props) => props.color};
    font-size: 14px;
    font-weight: 500;
    border-radius: 30px;
    position: relative;
`;

const getTagTheme = (state: VISIT_STATUS) => {
    switch (state) {
        case "CHECK_IN":
            return { title: "방문 중", color: "#899C5B", backgroundColor: "#EAFDD2" };
        case "CHECK_OUT":
            return {
                title: "방문 완료",
                color: "#8474E6",
                backgroundColor: "#EBE8FC",
            };
        case "MISSED_CHECK_OUT":
            return {
                title: "체크아웃 누락",
                color: "#FF3E3E",
                backgroundColor: "#FFECEC",
            };
        case "NOT_VISITED":
            return {
                title: "미방문",
                color: "#FFB800",
                backgroundColor: "#FFF6DF",
            };
        case "PENDING":
            return {
                title: "방문 대기",
                color: "#7F93A9",
                backgroundColor: "#E6EEF7",
            };
        case "UPCOMING":
            return {
                title: "방문 예정",
                color: "#f0793c",
                backgroundColor: "#fdf5f2",
            };
        default:
            return {
                title: "",
                color: "white",
                backgroundColor: "black",
            };
    }
};

const StateTag = ({
    state,
    allowSelect = false,
    onChangeState = () => {},
}: {
    onChangeState?: (value: string) => void;
    state: VISIT_STATUS;
    allowSelect?: boolean;
}) => {
    const { color, backgroundColor, title } = getTagTheme(state);
    const [open, setOpen] = useState<boolean>(false);

    if (state) {
        if (!allowSelect || state === "CHECK_OUT") {
            return (
                <TagContainer color={color} backgroundColor={backgroundColor}>
                    {title}
                </TagContainer>
            );
        } else {
            return (
                <Select_V2
                    onChange={onChangeState}
                    styles={{
                        items: css`
                            top: 40px;
                        `,
                    }}
                    data={["방문 완료"]}
                    onChangeSelectOpen={(value) => setOpen(value)}
                    RenderInput={
                        <TagContainer
                            color={color}
                            backgroundColor={backgroundColor}
                            css={css`
                                width: max-content;
                                padding: 0 12px;
                                max-width: 130px;
                            `}
                        >
                            {title}
                            <div
                                css={css`
                                    display: flex;
                                    align-items: center;
                                    margin-left: 4px;
                                    transform: ${open ? "rotate(180deg)" : "rotate(0deg)"};
                                    transition: 0.5s ease all;
                                `}
                            >
                                <Icon name="top-arrow" color={color} />
                            </div>
                        </TagContainer>
                    }
                />
            );
        }
    } else return <></>;
};

export default StateTag;
